import React, { useEffect } from 'react';
import { Container, Nav, Navbar, NavDropdown, NavLink } from 'react-bootstrap';
import logo from "../../assets/images/logo.png"; // Ensure the file exists at this path
import minilogo from "../../assets/images/minilogo.png";
import defaultImage from "../../assets/images/default_user.jpg"; 
import { useAppContext } from '../../context/appcontext';
import { Link } from 'react-router-dom';
import LogoutButton from './LogoutButton';
import "../../index.css";
const Header: React.FC = () => {

  const { loggedinuser, setLoggedinuser, authChecked, setAuthChecked, sidebarCollapsed, setIsCollapsed, showSidebar, setShowSidebar } = useAppContext();
  // useEffect(() => {
  //   if (window.innerWidth <= 990) {
  //     setIsCollapsed((prev) => {
  //       const newState = !prev;
    
  //       const contentArea = document.querySelector(".content-area") as HTMLElement | null;
  //       const navBrand = document.querySelector(".navbar.default-layout .navbar-brand-wrapper") as HTMLElement | null;
  //       const navMenu = document.querySelector(".navbar.default-layout .navbar-menu-wrapper") as HTMLElement | null;
    
  //       if (contentArea && navBrand && navMenu) {
          
  //         contentArea.style.marginLeft = newState ? "10px" : "250px"; // Adjust margin based on the state
  //         if (newState) {
  //           navBrand.classList.add('collapsed');
  //           navMenu.classList.add('collapsed');
  //         } else {
  //           navBrand.classList.remove('collapsed');
  //           navMenu.classList.remove('collapsed');
  //         }
  //       } 
  //       return newState;
  //     });
  //   } else {
  //      setIsCollapsed((prev) => {
  //       const newState = !prev;
    
  //       const contentArea = document.querySelector(".content-area") as HTMLElement | null;
  //       const navBrand = document.querySelector(".navbar.default-layout .navbar-brand-wrapper") as HTMLElement | null;
  //       const navMenu = document.querySelector(".navbar.default-layout .navbar-menu-wrapper") as HTMLElement | null;
    
  //       if (contentArea && navBrand && navMenu) {
          
  //         contentArea.style.marginLeft = newState ? "70px" : "250px"; // Adjust margin based on the state
  //         if (newState) {
  //           navBrand.classList.add('collapsed');
  //           navMenu.classList.add('collapsed');
  //         } else {
  //           navBrand.classList.remove('collapsed');
  //           navMenu.classList.remove('collapsed');
  //         }
  //       } 
  //       return newState;
  //     });
  //   }
  //        }, []);


  const toggleSidebar = () => {
    if (window.innerWidth <= 990) {
      // Mobile toggle
      setShowSidebar((prev) => !prev);
    } else {
      setIsCollapsed((prev) => {
        const newState = !prev;
    
        const contentArea = document.querySelector(".content-area") as HTMLElement | null;
        const navBrand = document.querySelector(".navbar.default-layout .navbar-brand-wrapper") as HTMLElement | null;
        const navMenu = document.querySelector(".navbar.default-layout .navbar-menu-wrapper") as HTMLElement | null;
    
        if (contentArea && navBrand && navMenu) {
          
          contentArea.style.marginLeft = newState ? "70px" : "270px"; // Adjust margin based on the state
          if (newState) {
            navBrand.classList.add('collapsed');
            navMenu.classList.add('collapsed');
          } else {
            navBrand.classList.remove('collapsed');
            navMenu.classList.remove('collapsed');
          }
        } 
        return newState;
      });
    }
  };
  

  return (
    (authChecked && (
        <nav className="navbar default-layout header-bg col-lg-12 col-12 p-0 fixed-top d-flex headerShadow">
            <div className="navbar-brand-wrapper text-center d-flex align-items-top justify-content-center">
            {!sidebarCollapsed && 
                <a className="navbar-brand brand-logo" href="/">
                    <img src={logo} alt="logo" data-themekey="#" />
                </a>}

                {sidebarCollapsed && 
                  <a className="navbar-brand brand-logo-mini" href="/">
                    <img id="smalllogo" src={minilogo} alt="logo" data-themekey="#" />
                  </a>
                }
            </div>
            <div className="navbar-menu-wrapper d-flex align-items-center hamburger onSmallerOnly">
            <button className="navbar-toggler navbar-toggler align-self-center onSmallScreen " 
                onClick={toggleSidebar}
                type="button">
                    <i className="fa fa-bars" aria-hidden="true">
                    </i>
                </button>
                <h1>Nippon Express Workflow System 
                </h1>
                <button className="navbar-toggler navbar-toggler align-self-center d-lg-none onSmallerOnlyButton" 
                onClick={toggleSidebar}
                type="button">
                    <i className="fa fa-bars" aria-hidden="true">
                    </i>
                </button>
            </div>
         <Nav className="d-flex" style={{position: "absolute",  right: "0"}}>
          <NavDropdown title={<img src={loggedinuser?.profileImage ?? defaultImage} alt="Avatar" style={{ borderRadius: '50%',    width: '32px' }} />} align="end">
            <NavDropdown.Item>
  <LogoutButton />
</NavDropdown.Item>
          </NavDropdown>
        </Nav> 

        </nav>
  )
  ));
};

export default Header;
